"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabManager = void 0;
var Directions;
(function (Directions) {
    Directions[Directions["Forward"] = 1] = "Forward";
    Directions[Directions["Backward"] = -1] = "Backward";
})(Directions || (Directions = {}));
var KeyNames;
(function (KeyNames) {
    KeyNames["Tab"] = "Tab";
})(KeyNames || (KeyNames = {}));
var tabManager = function () {
    var tabLoopHandler;
    function collectElements(container) {
        if (!(container && container.querySelectorAll)) {
            return {};
        }
        var elements = container.querySelectorAll('button, [href], input:not([type=hidden]):not([aria-hidden="true"]), select, textarea, [tabindex]:not([tabindex="-1"]), [tabable]');
        if (!elements.length) {
            return {};
        }
        return {
            firstElement: findFirstElement(elements),
            lastElement: findLastElement(elements),
        };
    }
    function findFirstElement(collection) {
        var size = collection.length;
        for (var i = 0; i < size; i++) {
            if (collection[i].offsetParent) {
                return collection[i];
            }
        }
    }
    function findLastElement(collection) {
        var size = collection.length;
        for (var i = size - 1; i >= 0; i--) {
            if (collection[i].offsetParent) {
                return collection[i];
            }
        }
    }
    function getFirstElement(container) {
        var firstElement = collectElements(container).firstElement;
        return firstElement;
    }
    function getLastElement(container) {
        var lastElement = collectElements(container).lastElement;
        return lastElement;
    }
    function setInitFocus(container) {
        var firstElement = getFirstElement(container);
        if (firstElement) {
            firstElement.focus();
            firstElement.scrollIntoView();
        }
    }
    function setInitFocusOnNewWindow(container) {
        if (container && container.focus) {
            container.focus();
        }
    }
    function setTabLoop(container) {
        tabLoopHandler = function (e) {
            onKeyDown(e, container);
        };
        document.addEventListener('keydown', tabLoopHandler);
    }
    function removeTabLoop() {
        if (tabLoopHandler) {
            document.removeEventListener('keydown', tabLoopHandler);
        }
    }
    function isSameElement(elem1, elem2) {
        return (elem1 === elem2 ||
            (Boolean(elem1.name) && Boolean(elem2.name) && elem1.name === elem2.name));
    }
    function onKeyDown(e, container) {
        if (e.key === KeyNames.Tab) {
            var direction = e.shiftKey ? Directions.Backward : Directions.Forward;
            var target = e.target;
            var _a = collectElements(container), firstElement = _a.firstElement, lastElement = _a.lastElement;
            if (!lastElement || !firstElement) {
                return;
            }
            if (direction === Directions.Forward) {
                if (target === document.body || isSameElement(target, lastElement)) {
                    e.preventDefault();
                    firstElement.focus();
                    return;
                }
            }
            if (direction === Directions.Backward) {
                if (target === document.body || isSameElement(target, firstElement)) {
                    e.preventDefault();
                    lastElement.focus();
                    return;
                }
            }
        }
    }
    return {
        setTabLoop: setTabLoop,
        removeTabLoop: removeTabLoop,
        setInitFocus: setInitFocus,
        setInitFocusOnNewWindow: setInitFocusOnNewWindow,
        getFirstElement: getFirstElement,
        getLastElement: getLastElement,
        collectElements: collectElements,
    };
};
exports.tabManager = tabManager;
//# sourceMappingURL=tabManager.js.map